var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box no-fav-box"})
}
var staticRenderFns = []

export { render, staticRenderFns }